import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { isSelectionAtStartOfNode, isSelectionAtEndOfNode } from '@atlaskit/editor-common/selection';
import { SELECTION_CATEGORY } from './analytics/enums';
function findFirstDeco(decorationSet, key) {
  var found = decorationSet.find(undefined, undefined, function (spec) {
    return spec.key === key;
  });
  return found.length > 0 ? found[0] : undefined;
}
export function getAIHighlightPositions(_ref) {
  var modalDecorationSet = _ref.modalDecorationSet;
  if (!modalDecorationSet) {
    return undefined;
  }
  var inlineDecoration = findFirstDeco(modalDecorationSet, 'inlineDecoration');
  if (inlineDecoration) {
    return [inlineDecoration.from, inlineDecoration.to];
  }
  var startWidget = findFirstDeco(modalDecorationSet, 'generatedStartWidget');
  var endWidget = findFirstDeco(modalDecorationSet, 'generatedEndWidget');
  if (startWidget && endWidget) {
    return [startWidget.from, endWidget.to];
  }
  return undefined;
}
export function getSelectionCategory(editorView, positions) {
  var state = editorView.state;
  var _positions = _slicedToArray(positions, 2),
    start = _positions[0],
    end = _positions[1];
  var isEmptySelection = start === end;
  var $start = state.doc.resolve(start);
  var $end = state.doc.resolve(end);
  var isSameParent = $start.sameParent($end);
  var isBeginningOfDoc = $start.pos === $start.depth;
  var isEndOfDoc = state.doc.nodeSize - $end.pos - 2 === $end.depth;
  var isStartOfParentNode = isSelectionAtStartOfNode($start, $start.parent);
  var isEndOfParentNode = isSelectionAtEndOfNode($end, $end.parent);
  if (isEmptySelection) {
    return SELECTION_CATEGORY.EMPTY;
  }
  if (isBeginningOfDoc && isEndOfDoc) {
    return SELECTION_CATEGORY.FULL_DOCUMENT;
  }
  if (isSameParent) {
    if (isStartOfParentNode && isEndOfParentNode) {
      return SELECTION_CATEGORY.FULL_SINGLE_BLOCK;
    }
    return SELECTION_CATEGORY.PARTIAL_SINGLE_BLOCK;
  }
  if (isStartOfParentNode && isEndOfParentNode) {
    return SELECTION_CATEGORY.FULL_MULTIPLE_BLOCKS;
  }
  return SELECTION_CATEGORY.PARTIAL_MULTIPLE_BLOCKS;
}